import { format, isToday, isYesterday, parseISO } from 'date-fns'
import { SISSync, SISWorker } from '../consts'

export interface MetaInfoProps {
  lastEditedBy: string
  lastEditedAt: string
}

export const buildMetaInfo = (
  username?: string,
  date?: string
): MetaInfoProps => {
  return {
    lastEditedBy: resolveUsername(username),
    lastEditedAt: resolveDate(date)
  }
}

const resolveUsername = (username?: string): string => {
  if (!username?.trim()) return 'Unknown'

  switch (username) {
    case SISWorker:
      return SISSync
    default:
      return username
  }
}

const resolveDate = (date?: string): string => {
  if (!date) return 'Unknown'

  try {
    const parsed = parseISO(date)
    if (isNaN(parsed.getTime())) return 'Unknown'

    switch (true) {
      case isYesterday(parsed):
        return `Yesterday at ${format(parsed, 'h:mm a')}`
      default:
        return format(parsed, 'MMM dd, yyyy') + ' at ' + format(parsed, 'h:mm a')
    }
  } catch (err) {
    console.error('[resolveDate] Failed to parse date:', err)
    return 'Unknown'
  }
}
